module.exports = __webpack_public_path__ + "cd455783/img/cadBim.e369a02a.png";